import React, { Component } from "react";
import classNames from "classnames";
// import _ from 'lodash';
import {RichText as PrismicRichText} from 'prismic-reactjs';
// import {Link} from 'react-router-dom';
import {PrismicConfig} from "../../config";
import "./Grid.css";
import RichText from "../RichText/RichText";

export default class Grid extends Component {

	componentDidMount() {
		
	}

	sectionClasses() {
		let classes = {
			"grid": true,
		}
		return classNames(classes);
	}
	
	render() {
		const { content } = this.props;

		console.log()
		return (
			content.map((item, index) => (<div key={index} className="grid-wrapper">
				<RichText key={1} content={item.col1} />
				<RichText key={2} content={item.col2} />
			</div>))

		);
	}
}	


// WEBPACK FOOTER //
// ./src/components/Grid/Grid.js